/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LabExamsDetailsAliases {
  CONTEXTUAL_BAR_LAB_EXAMS = 'contextual-bar-lab-exams',
  FIELD_1 = 'field-1',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_NR_ATENDIMENTO = 'field-nr-atendimento',
  FORM_LAB_EXAMS_DETAILS = 'form-lab-exams-details',
  IMAGE_VIEWER_BUTTON = 'image-viewer-button',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_1 = 'input-1',
  INPUT_REFERENCE = 'input-reference',
  LAYOUT_LAB_EXAMS_DETAILS = 'layout-lab-exams-details',
  LOADER = 'loader',
  MEDIA_CONTAINER_NON_LAB = 'media-container-non-lab',
  PANEL_LAB_EXAMS = 'panel-lab-exams',
  PANEL_LOADER = 'panel-loader',
  PANEL_MEDIA_CONTAINER_PDF_VIEWER = 'panel-media-container-pdf-viewer',
  PANEL_MENU_CONTEXTUALBAR = 'panel-menu-contextualbar',
  PANEL_PDF_VIEWER_EXAM_DETAILS = 'panel-pdf-viewer-exam-details',
  PDF_VIEWER_EXAM_DETAILS = 'pdf-viewer-exam-details',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_10 = 'text-10',
  TEXT_DSRESULT = 'text-dsresult',
  TEXT_DSSTATUS = 'text-dsstatus',
  TEXT_NR_ATENDIMENTO_VALUE = 'text-nr-atendimento-value',
}
export { LabExamsDetailsAliases };
